@if (wrapInListItem()) {
  @for (item of counter(count()); track $index) {
    <li class="product-card-skeleton__list-item">
      <div class="product-card-skeleton product-card-skeleton--listing">
        <div class="product-card-skeleton__listing-media">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '100%',
              'border-radius': '0',
              margin: '0',
            }"></ngx-skeleton-loader>
          <div class="product-card-skeleton__listing-code">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '3.5rem',
                height: '1.25rem',
                'border-radius': '0.375rem',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
        </div>

        <div class="product-card-skeleton__listing-info">
          <div
            class="product-card-skeleton__listing-text project-card-skeleton__listing-text">
            <ngx-skeleton-loader
              count="1"
              class="product-card-skeleton__listing-title"
              [theme]="{
                width: '78%',
                height: '0.875rem',
                'border-radius': '0.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              class="product-card-skeleton__listing-subtitle"
              [theme]="{
                width: '52%',
                height: '0.75rem',
                'border-radius': '0.25rem',
                margin: '0.25rem 0 0 0',
              }"></ngx-skeleton-loader>
          </div>
        </div>

        <div
          class="product-card-skeleton__listing-footer project-card-skeleton__listing-footer">
          <ngx-skeleton-loader
            count="1"
            class="project-card-skeleton__listing-description"
            [theme]="{
              width: '100%',
              height: '0.75rem',
              'border-radius': '0.25rem',
              margin: '0',
            }"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            class="project-card-skeleton__listing-description"
            [theme]="{
              width: '72%',
              height: '0.75rem',
              'border-radius': '0.25rem',
              margin: '0.375rem 0 0 0',
            }"></ngx-skeleton-loader>
        </div>
      </div>
    </li>
  }
} @else {
  <div [ngClass]="containerClasses()">
    @for (item of counter(count()); track $index) {
      <div class="product-card-skeleton product-card-skeleton--listing">
        <div class="product-card-skeleton__listing-media">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '100%',
              'border-radius': '0',
              margin: '0',
            }"></ngx-skeleton-loader>
          <div class="product-card-skeleton__listing-code">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '3.5rem',
                height: '1.25rem',
                'border-radius': '0.375rem',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
        </div>

        <div class="product-card-skeleton__listing-info">
          <div
            class="product-card-skeleton__listing-text project-card-skeleton__listing-text">
            <ngx-skeleton-loader
              count="1"
              class="product-card-skeleton__listing-title"
              [theme]="{
                width: '78%',
                height: '0.875rem',
                'border-radius': '0.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              class="product-card-skeleton__listing-subtitle"
              [theme]="{
                width: '52%',
                height: '0.75rem',
                'border-radius': '0.25rem',
                margin: '0.25rem 0 0 0',
              }"></ngx-skeleton-loader>
          </div>
        </div>

        <div
          class="product-card-skeleton__listing-footer project-card-skeleton__listing-footer">
          <ngx-skeleton-loader
            count="1"
            class="project-card-skeleton__listing-description"
            [theme]="{
              width: '100%',
              height: '0.75rem',
              'border-radius': '0.25rem',
              margin: '0',
            }"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            class="project-card-skeleton__listing-description"
            [theme]="{
              width: '72%',
              height: '0.75rem',
              'border-radius': '0.25rem',
              margin: '0.375rem 0 0 0',
            }"></ngx-skeleton-loader>
        </div>
      </div>
    }
  </div>
}
